module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/transform.js
// module id = 1726
// module chunks = 0